<!--=====================================
=            WIDGETLISTSPARK            =
======================================-->
<template>
  <v-card  class="ml-2 rounded-lg"  :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'">

    <v-card  height="300" color="primary">
      <v-card-text dark class="white--text subtitle-1 font-weight-black">Navigation optimization
      </v-card-text>
      <div id="spark2" style="height:200px"></div>
    </v-card>

    <v-card-text   :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'">
      <v-container class="transparent"   >
        <v-row no-gutters color="transparent">
          <v-col md="12" cols="12" sm="12">
            <v-card class="pa-2 mt-n10 rounded-lg ma-5 mb-15   outlined" flat height="140" color="primary " tile>
              <v-list-item three-line>
                <v-list-item-avatar tile size="90"  color="primary lighten-1" class="green--text rounded-lg">
                  <v-icon size="50" dark>
                    loyalty
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>

                  <v-list-item-title class="subtitle-2  white--text font-weight-medium">
                    Strategy planning
                  </v-list-item-title>
                  <v-list-item-subtitle class="subtitle-1 font-weight-bold white--text font-weight-medium">Fonwderfully</v-list-item-subtitle>
                </v-list-item-content>


              </v-list-item>
            </v-card>
            <v-card    :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" class="pa-2 mt-5 rounded-lg ma-5 mb-10   outlined" flat height="140" color="primary" tile>
              <v-list-item  three-line>
                <v-list-item-avatar tile size="90" color="primary lighten-2" class="rounded-lg">
                  <v-icon size="50" dark>
                    source
                  </v-icon>
                </v-list-item-avatar>  <v-list-item-content>

                  <v-list-item-title class="subtitle-2  white--text font-weight-medium">
                    Strategy planning
                  </v-list-item-title>
                  <v-list-item-subtitle class="subtitle-1 font-weight-bold white--text font-weight-medium">Fonwderfully</v-list-item-subtitle>
                </v-list-item-content>



              </v-list-item>
            </v-card>

          </v-col>


        </v-row>

     
      </v-container>

    </v-card-text>
  </v-card>

</template>
<script>
  export default {
    
    mounted() {
      var randomizeArray = function (arg) {
        var array = arg.slice();
        var currentIndex = array.length,
          temporaryValue, randomIndex;

        while (0 !== currentIndex) {

          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;

          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }

        return array;
      }

      // data for the sparklines that appear below header area
      var sparklineData = [47, 45, 54, 38, 56, 24, 65, 31, 37, 39, 62, 51, 35, 41, 35, 27, 93, 53, 61, 27, 54, 43, 19,
        46
      ];


    

      var spark2 = {
        chart: {
          type: 'area',
          height: 220,
          sparkline: {
            enabled: true
          },
        },
        stroke: {
          curve: 'straight'
        },
        fill: {
          opacity: 0.3,
        },
        series: [{
          data: randomizeArray(sparklineData)
        }],
        yaxis: {
          min: 0
        },
        colors: ['#B0E0E6'],
        title: {

        }, tooltip: {
         
          theme:'dark'
        },
        subtitle: {
          text: '',
          offsetX: 0,
          style: {

          }
        }
      }

      var spark2 = new ApexCharts(document.querySelector("#spark2"), spark2);
      spark2.render();


    },
  }
</script>
<style>
  #spark2 {
  width: 370px;
  padding-top: 10px;
    background-color: transparent;


  }
  .card-light {
    border-radius: 1em;
    border: 1px solid rgba(255, 255, 255, 0.5);
    text-shadow: 0 0 1em rgba(0, 0, 0, 0.5);
    background: rgba(255, 255, 255, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }  .card-dark {
    border-radius: 1em;
    border: 1px solid rgba(0, 0, 0, 0.5);
    text-shadow: 0 0 1em rgba(245, 245, 245, 0.5);
    background: rgba(0, 0, 0, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }
</style>


<!--====  End of WIDGETLISTSPARK  ====-->
